import { mapApprover } from './mapApprover'
import { type ApprovalPoolConstructorData } from '../../entities/internal/ApprovalPool'
import { type ApproverApiModel } from '../api-models/ApproverApiModel'

export const mapApprovalPool = (approvalPoolData: {
  approvers: ApproverApiModel[]
  group_id: number
  group_name: string
  level: number
}): ApprovalPoolConstructorData => {
  return {
    level: approvalPoolData.level,
    groupName: approvalPoolData.group_name,
    groupId: approvalPoolData.group_id,
    members: approvalPoolData.approvers.map((approver) =>
      mapApprover(approver)
    ),
  }
}
